<template>
  <br />
  <h2 class="text-center my-2">CLIENT DAILY CASH BALANCES</h2>
  <br />
  <div v-if="displayEmptyBalances == false">
    <div class="fluid mx-3 shadow-3">
        <DataTable :value="cashBalances"
                    dataKey="id" :rowHover="true"
                    stripedRows responsiveLayout="stack"
                    showGridlines
                    breakpoint="1024px"
                    :paginator="true"
                    :rows="8"
                    class="datatable-retailClient">
            <Column field="clientId" header="ID" headerStyle="width: 1vw"></Column>
            <Column field="firstLastName" header="Client" headerStyle="width: 5vw"></Column>
            <Column field="inputDate" header="For Date" headerStyle="width: 3vw"></Column>
            <Column field="cifNumber" header="CIF No" headerStyle="width: 3vw"></Column>
            <Column field="accountNumber" header="Account No" headerStyle="width: 4vw"></Column>
            <Column field="accountCurrency" header="Currency" headerStyle="width: 3vw"></Column>
            <Column field="currentBalance" header="Balance" dataType="numeric" headerStyle="width: 4vw">
               <template #body="{data}">
                    {{formatCurrency(data.currentBalance)}}
                </template>
            </Column>
        </DataTable>
     </div>
  </div>
   <div v-else>
    <h3 class="text-center my-2">NO CASH BALANCE FOUND FOR THIS CLIENT</h3>
    <br />
    <hr class="mx-4 shadow-2"/>
   </div>
   <br />
  <div>
    <Button class="l-2 m-4 mx-3 shadow-4 p-button-lg"
    icon="pi pi-step-backward"
    label="BACK&nbsp;"
    id="submitButton"
    @click.prevent="$router.back()" />
  </div>
</template>

<script>
import { getClientCashBalance } from '@/gateway'

export default {
  name: 'DailyCashBalance',
  inheritAttrs: false,
  data () {
    return {
      cashBalances: [],
      displayEmptyBalances: false
    }
  },
  methods: {
    async init () {
      const response = await getClientCashBalance({ id: this.id })
      if (response.result.length !== 0) {
        this.cashBalances = response.result
      } else {
        this.displayEmptyBalances = true
      }
    },
    formatCurrency (value) {
      return value.toLocaleString('en-US', { style: 'decimal', maximumFractionDigits: 2, minimumFractionDigits: 2 })
    }
  },
  mounted () {
    this.id = this.$route.params.id
    this.init()
  }
}
</script>

<style lang="scss" scoped>
::v-deep() {
  .p-datatable .p-datatable-thead > tr > th {
    background-color: $middleBlue!important;
    color: $textColor;
    border: 1px solid $borderColour!important;
    font-size: 18px;
    font-weight: 600;
  }
  .p-datatable .p-datatable-tbody > tr > td {
    padding: .4rem .4rem;
    color: $darkTextColour;
    font-family:'Poppins', sans-serif;
    font-weight: 400;
  }
  .p-paginator-current {
        margin-right: auto;
    }
  .retailClient-badge {
      @include statusBadge
  };
  #disabled {
    background: $textColor!important;
    color: $middleBlue!important;
  };
  #searchtext {
    margin-left: 1rem!important;
    min-width: 40vw;
  };
};
</style>
